import memberhubConstants from '~/constants/memberhub.constants'
export function useOneTap () {
  const { devices } = deviceChecker()
  const layoutStore = useLayoutsStore()
  const userStore = useUserStore()
  const route = useRoute()
  const { googleClientId } = useRuntimeConfig().public
  const { $bus, $toast, $tracking } = useNuxtApp()

  const googleAttempt = ref(0)
  const userLoggedIn = computed(() => {
    return userStore.isUserLoggedIn
  })

  const isMobile = computed(() => (devices.isMobile.value || devices.isTablet.value))
  let googleScriptAdded = false
  let googleInitialized = false

  onMounted(() => {
    nextTick().then(() => {
      oneTapHandler()
      loggedInListener()
    })
  })

  // Watch for device or route changes to re-evaluate One Tap
  watch([isMobile, () => route.path], () => {
    oneTapHandler()
  })

  /*
   * One tap handler & filtering conditions
   */
  function oneTapHandler () {
    const currentPath = trailingSlash(route.path)
    // Desktop: enable One Tap for all routes
    // Mobile: disable One Tap for MOBILE_DISABLED_ROUTES
    const isDesktop = !isMobile.value
    const isMobileDisabled = isMobile.value && memberhubConstants.MOBILE_DISABLED_ROUTES.includes(currentPath)

    if (!userLoggedIn.value) {
      if (isDesktop) {
        googleOneTap()
      } else if (!isMobileDisabled) {
        googleOneTap()
      } else {
        dismissOneTap()
      }
    } else {
      dismissOneTap()
    }
  }
  /*
   * Google one tap plugin initialization
   */
  function googleOneTap () {
    if (!googleScriptAdded) {
      const link = document.createElement('script')
      link.src = 'https://accounts.google.com/gsi/client'
      link.id = 'google-one-tap-script'
      document.getElementsByTagName('head')[0].appendChild(link)
      googleScriptAdded = true
    }
    nextTick().then(() => {
      if (window.google?.accounts) {
        // initialize() should only be called once per loaded GSI script.
        // Calling it on every route change triggers a GSI_LOGGER warning and
        // resets the client config. The guard is cleared in dismissOneTap()
        // when the script is removed, so re-entry re-initializes correctly.
        if (!googleInitialized) {
          try {
            window.google.accounts.id.initialize({
              client_id: googleClientId,
              cancel_on_tap_outside: false,
              itp_support: true,
              callback: listenOneTapCallback
            })
            googleInitialized = true
          } catch (e) {
            // fail silently
          }
        }
        promptOneTap()
      } else if (!googleAttempt.value) {
        setTimeout(() => {
          googleAttempt.value++
          googleOneTap()
        }, 1000)
      }
    })
  }
  /*
   * One tap prompt handler
   */
  function promptOneTap () {
    nextTick().then(() => {
      if (window.google?.accounts) {
        window.google.accounts.id.prompt()
      }
    })
  }
  /*
   * Dismissing one tap prompt
   */
  function dismissOneTap () {
    if (window.google?.accounts) {
      window.google.accounts.id.cancel()
    }
    // Remove Google One Tap script if present
    const script = document.getElementById('google-one-tap-script')
    if (script) {
      script.remove()
      googleScriptAdded = false
      googleInitialized = false
    }
  }
  /*
   * Logged in event listener
   */
  function loggedInListener () {
    $bus.off('logged-in')
    $bus.on('logged-in', () => {
      nextTick().then(() => {
        dismissOneTap()
      })
    })
  }
  /*
   * Auth callback listener
   * @param e
   */
  function listenOneTapCallback (e) {
    layoutStore.setPageLoader(true)
    nextTick().then(() => {
      $tracking.customEvent('One Tap Click', {})
      userStore.googleOneTapAuthInit({
        state: userStore.defaultAuthState,
        id_token: e.credential
      }).catch(() => {
        layoutStore.setPageLoader(false)
        $toast.error()
      })
    })
  }
}
